import * as React from 'react';
import { Input, InputProp } from '@lendi-ui/text-input';

import { EventTracking } from '@funnels/types';
import { useNumeral, UseNumeralOptions } from '@funnels/hooks';

export interface UncontrolledNumericalInputProps extends EventTracking, Omit<InputProp, 'onChange'> {
  onChange?: (value?: number) => void;
  options?: UseNumeralOptions;
  isDisabled?: boolean;
}

function UncontrolledNumericalInput(props: UncontrolledNumericalInputProps) {
  const { isError, onChange, options, ...otherProps } = props;
  const [value, setNumeralValue] = useNumeral(otherProps.value, options);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const val = setNumeralValue(e.target.value);

    if (onChange) {
      onChange(val);
    }
  }

  return <Input {...otherProps} inputMode="decimal" size="md" value={value} onChange={handleChange} />;
}

export default UncontrolledNumericalInput;
